import { Map } from 'immutable'

const SET_ERROR_MESSAGE = 'error/MESSAGE'

const defaultState = Map({
  errorMessage: null
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return state.update('errorMessage', previousMessage => action.payload)

    default:
      return state
  }
}

export function setError(message) {
  return function d(dispatch) {
    if (!message) {
      return dispatch({ type: SET_ERROR_MESSAGE, payload: null })
    }

    dispatch({ type: SET_ERROR_MESSAGE, payload: message })
  }
}



// WEBPACK FOOTER //
// ./src/ducks/error.js